module.exports = __webpack_public_path__ + "static/media/logo_app.d48826d4.svg";